import { LayoutRenderer, RowCollectionLayout } from './types';
import { HeroTwoLayout } from './HeroTwoLayout';
import { WideGridLayout } from './WideGridLayout';
import { SquareGrid3x2Layout } from './SquareGrid3x2Layout';
import {
  GridSixLayout,
  GridTwoByTwoLayout,
  HeroDoubleTallGridLayout,
  RowFiveLayout,
  RowFourLayout,
  RowSixLayout,
  RowThreeLayout,
  RowTwoLayout,
  TallGridTwoByTwoLayout,
} from './GridStubLayouts';
import { HeroOneLayout } from './HeroOneLayout';

export const layoutRegistry: Partial<Record<RowCollectionLayout, LayoutRenderer>> = {
  'hero-1': HeroOneLayout,
  'hero-2': HeroTwoLayout,
  'wide+grid3x3': WideGridLayout,
  'square+grid3x2': SquareGrid3x2Layout,
  'row-3': RowThreeLayout,
  'row-5': RowFiveLayout,
  'row-2': RowTwoLayout,
  'row-4': RowFourLayout,
  'row-6': RowSixLayout,
  'row-6-box': RowSixLayout,
  'grid-6': GridSixLayout,
  'grid-2x2': GridTwoByTwoLayout,
  'tall+grid2x2': TallGridTwoByTwoLayout,
  'hero-double-tall-grid': HeroDoubleTallGridLayout,
};
